// Функция для плавного скролла с динамическим header
const smoothScroll = (selector, headerSelector = null, extraOffset = 0) => {
    const target = document.querySelector(selector);
    if (!target) return;

    let headerOffset = 0;
    if (headerSelector) {
        const header = document.querySelector(headerSelector);
        if (header) {
            headerOffset = header.getBoundingClientRect().height;
        }
    }

    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset - extraOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
};

// Привязка ко всем ссылкам
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        const url = new URL(href, window.location.origin);
        const hash = url.hash;
        const pathname = url.pathname;

        if (pathname === window.location.pathname) {
            if (hash) {
                e.preventDefault();
                smoothScroll(hash, '.header', 10);
            }
        } else {
            if (hash) {
                sessionStorage.setItem('scrollToHash', hash);
            }
        }
    });
});

// После загрузки страницы проверяем, нужно ли скроллить
window.addEventListener('DOMContentLoaded', () => {
    const hash = sessionStorage.getItem('scrollToHash');
    if (hash) {
        sessionStorage.removeItem('scrollToHash');
        smoothScroll(hash, '.header', 10);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-fancybox]', {});
});

// Price
(() => {
    const nf = new Intl.NumberFormat('uk-UA'); // "26 472"
    const priceEls = document.querySelectorAll('.tariffs__plan-price[data-price]');

    priceEls.forEach((el) => {
        const raw = (el.dataset.price || '').trim();
        const value = Number(raw.replace(',', '.'));
        if (!Number.isFinite(value)) return;

        const currency = el.dataset.currency || 'грн';
        const formattedNumber = nf.format(Math.round(value));

        el.textContent = `${formattedNumber}\u00A0${currency}`;
    });
})();

// Form
(() => {
    const popup = document.querySelector('.popup');
    const container = popup?.querySelector('.popup__container');
    const closeBtn = popup?.querySelector('.popup__btn-close');

    const orderHint = document.getElementById('orderHint');
    const form = popup?.querySelector('.order-form');

    const planIdInput = document.getElementById('plan_id');
    const monthsInput = document.getElementById('period_months');
    const usersInput = document.getElementById('users');

    const honeypotInput = form?.querySelector('input[name="company"]');

    const phoneInput = form?.querySelector('#phone');
    const phoneField = phoneInput?.closest('.field');
    const phoneError = form?.querySelector('#phoneError'); // <p id="phoneError"></p> под полем
    const nameInput = form.querySelector('#name');
    const nameField = nameInput.closest('.field');
    const nameError = form.querySelector('#nameError');

    const nbsp = '\u00A0';

    if (
        !popup || !container || !closeBtn || !orderHint || !form ||
        !planIdInput || !monthsInput || !usersInput || !honeypotInput ||
        !phoneInput || !phoneField || !phoneError
    ) return;

    let formOpenedAt = 0;

    /* ---------- UA mobile codes (2 digits after 0) ---------- */
    const UA_MOBILE_NDC = new Set([
        '39',
        '50', '66', '75', '95', '99',
        '63', '73', '93',
        '67', '68', '77', '96', '97', '98',
        '91', '92', '94',
    ]);

    /* ---------- declensions ---------- */

    function pluralizeMonths(n) {
        if (n === 1) return `1${nbsp}місяць`;
        if (n >= 2 && n <= 4) return `${n}${nbsp}місяці`;
        return `${n}${nbsp}місяців`;
    }

    function pluralizeUsers(n) {
        if (n === 1) return `1${nbsp}користувача`;
        if (n >= 2 && n <= 4) return `${n}${nbsp}користувача`;
        return `${n}${nbsp}користувачів`;
    }

    function buildOrderText({ title, months, users }) {
        const cleanTitle = title.replace(/^autodata\s+/i, '').trim();
        return `Для замовлення «Autodata${nbsp}${cleanTitle}» на ${pluralizeMonths(months)} на ${pluralizeUsers(users)} заповніть форму нижче.`;
    }

    /* ---------- phone: fixed prefix mask + correct caret ---------- */

    const PHONE_PREFIX = '+38 (';
    const MIN_POS = PHONE_PREFIX.length; // позиция, с которой начинаются цифры

    function setPhoneError(message) {
        if (message) {
            phoneField.classList.add('field--invalid');
            phoneError.textContent = message;
        } else {
            phoneField.classList.remove('field--invalid');
            phoneError.textContent = '';
        }
    }

    function setNameError(message) {
        if (message) {
            nameField.classList.add('field--invalid');
            nameError.textContent = message;
        } else {
            nameField.classList.remove('field--invalid');
            nameError.textContent = '';
        }
    }

    function getDigits(str) {
        return (str || '').replace(/\D/g, '');
    }

    // Получаем 10 цифр (0XXXXXXXXX), игнорируя префикс "38" в маске.
    function extractUserDigits10(value) {
        let d = getDigits(value);

        // digits из форматированной строки начинаются с 38...
        if (d.startsWith('38')) d = d.slice(2);

        // обычный сценарий: 0XXXXXXXXX
        if (d.startsWith('0')) return d.slice(0, 10);

        // если вставили 80XXXXXXXXX -> 0XXXXXXXXX
        if (d.startsWith('80') && d.length >= 11) return ('0' + d.slice(2, 11)).slice(0, 10);

        // если вставили 380XXXXXXXXX -> 0XXXXXXXXX
        if (d.startsWith('380') && d.length >= 12) return ('0' + d.slice(3, 12)).slice(0, 10);

        // если ввели без ведущего 0 — добавим
        if (d.length > 0 && d[0] !== '0') d = '0' + d;

        return d.slice(0, 10);
    }

    function formatUaFrom10(d10) {
        const a = d10.slice(0, 3);   // 0XX
        const b = d10.slice(3, 6);   // XXX
        const c = d10.slice(6, 8);   // XX
        const e = d10.slice(8, 10);  // XX

        let out = PHONE_PREFIX + a + ')';
        if (b) out += ` ${b}`;
        if (c) out += `-${c}`;
        if (e) out += `-${e}`;
        return out;
    }

    function isValidUaMobile10(d10) {
        if (!/^0\d{9}$/.test(d10)) return false;
        const ndc = d10.slice(1, 3); // XX после 0
        return UA_MOBILE_NDC.has(ndc);
    }

    function validateName(value) {
        const v = value.trim();

        if (v.length < 2) {
            return 'Введіть імʼя (мінімум 2 символи).';
        }

        if (v.length > 50) {
            return 'Імʼя занадто довге.';
        }

        if (!/^[A-Za-zА-Яа-яІіЇїЄєҐґ'ʼ\s-]+$/.test(v)) {
            return 'Імʼя може містити лише літери, пробіли, дефіс та' + nbsp + 'апостроф.';
        }

        return '';
    }

    // Считаем сколько "пользовательских" цифр находится слева от caret
    function getUserDigitIndex(value, caretPos) {
        const left = value.slice(0, Math.max(0, caretPos));
        let digitsLeft = (left.match(/\d/g) || []).length;

        const allDigits = getDigits(value);
        // префиксные "38" не считаем
        if (allDigits.startsWith('38') && digitsLeft >= 2) digitsLeft -= 2;

        return Math.max(0, digitsLeft);
    }

    // Ставим caret после N пользовательских цифр в форматированной строке
    function setCaretByUserDigitIndex(formatted, userDigitIndex) {
        if (userDigitIndex <= 0) {
            phoneInput.setSelectionRange(MIN_POS, MIN_POS);
            return;
        }

        let skippedPrefixDigits = 0;
        let seenDigits = 0;

        for (let i = 0; i < formatted.length; i++) {
            const ch = formatted[i];
            if (/\d/.test(ch)) {
                if (skippedPrefixDigits < 2) {
                    skippedPrefixDigits++; // пропускаем "38"
                } else {
                    seenDigits++;
                    if (seenDigits === userDigitIndex) {
                        const pos = i + 1;
                        phoneInput.setSelectionRange(pos, pos);
                        return;
                    }
                }
            }
        }

        phoneInput.setSelectionRange(formatted.length, formatted.length);
    }

    phoneInput.placeholder = 'Телефон*';

    // Лёгкая защита префикса
    phoneInput.addEventListener('focus', () => {
        if (!phoneInput.value) {
            phoneInput.value = PHONE_PREFIX + ')';
            phoneInput.setSelectionRange(MIN_POS, MIN_POS);
        }
    });

    // Улучшаем Backspace на разделителях
    phoneInput.addEventListener('keydown', (e) => {
        const pos = phoneInput.selectionStart ?? 0;

        if ((e.key === 'Backspace' || e.key === 'ArrowLeft') && pos <= MIN_POS) {
            e.preventDefault();
            phoneInput.setSelectionRange(MIN_POS, MIN_POS);
            return;
        }

        if (e.key === 'Backspace' && pos > MIN_POS) {
            const leftChar = phoneInput.value[pos - 1];
            if (leftChar && !/\d/.test(leftChar)) {
                e.preventDefault();
                let p = pos - 1;
                while (p > MIN_POS && !/\d/.test(phoneInput.value[p - 1])) p--;
                phoneInput.setSelectionRange(p, p);
            }
        }
    });

    phoneInput.addEventListener('input', () => {
        const caretPos = phoneInput.selectionStart ?? phoneInput.value.length;
        const userIndex = getUserDigitIndex(phoneInput.value, caretPos);

        const d10 = extractUserDigits10(phoneInput.value);

        if (d10.length === 0) {
            phoneInput.value = '';
            setPhoneError('');
            return;
        }

        const formatted = formatUaFrom10(d10);
        phoneInput.value = formatted;

        // Восстанавливаем caret корректно (а не в конец)
        setCaretByUserDigitIndex(formatted, userIndex);

        setPhoneError('');
    });

    nameInput.addEventListener('input', () => {
        setNameError('');
    });

    nameInput.addEventListener('blur', () => {
        const error = validateName(nameInput.value);
        setNameError(error);
    });

    phoneInput.addEventListener('blur', () => {
        const d10 = extractUserDigits10(phoneInput.value);

        if (d10.length === 0) {
            setPhoneError('');
            return;
        }

        if (d10.length < 10) {
            setPhoneError(`Введіть номер повністю: 10 цифр (наприклад, 063${nbsp}123${nbsp}45${nbsp}67).`);
            return;
        }

        if (!isValidUaMobile10(d10)) {
            setPhoneError('Невірний код оператора. Введіть український мобільний номер.');
            return;
        }

        phoneInput.value = formatUaFrom10(d10);
        setPhoneError('');
    });

    /* ---------- popup ---------- */

    function openPopup() {
        popup.classList.add('active');
        formOpenedAt = Date.now();
        form.querySelector('#name')?.focus?.();
    }

    function resetFormState() {
        form.reset();

        planIdInput.value = '';
        monthsInput.value = '';
        usersInput.value = '';
        orderHint.textContent = '';

        setPhoneError('');
    }

    function closePopup() {
        popup.classList.remove('active');
        resetFormState();
    }

    /* ---------- open by tariff button ---------- */

    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.tariffs__plan-btn');
        if (!btn) return;

        const title = (btn.dataset.title || '').trim();
        const planId = (btn.dataset.planId || '').trim();
        const months = Number(btn.dataset.periodMonths);
        const users = Number(btn.dataset.users);

        if (!title || !planId || !Number.isFinite(months) || !Number.isFinite(users)) return;

        orderHint.textContent = buildOrderText({ title, months, users });

        planIdInput.value = planId;
        monthsInput.value = String(months);
        usersInput.value = String(users);

        openPopup();
    });

    /* ---------- submit: anti-spam + validation ---------- */

    form.addEventListener('submit', (e) => {
        const nameErrorMsg = validateName(nameInput.value);
        if (nameErrorMsg) {
            e.preventDefault();
            setNameError(nameErrorMsg);
            nameInput.focus();
            return;
        }

        if (honeypotInput.value.trim() !== '') {
            e.preventDefault();
            return;
        }

        const elapsed = Date.now() - formOpenedAt;
        if (elapsed < 3000) {
            e.preventDefault();
            return;
        }

        if (!form.checkValidity()) {
            e.preventDefault();
            form.reportValidity();
            return;
        }

        const d10 = extractUserDigits10(phoneInput.value);

        if (d10.length < 10) {
            e.preventDefault();
            setPhoneError('Введіть номер повністю: 10 цифр (наприклад, 063 123 45 67).');
            phoneInput.focus();
            return;
        }

        if (!isValidUaMobile10(d10)) {
            e.preventDefault();
            setPhoneError('Вкажіть український мобільний номер: 10 цифр (наприклад, 063 123 45 67).');
            phoneInput.focus();
            return;
        }

        phoneInput.value = formatUaFrom10(d10);
        setPhoneError('');
    });

    /* ---------- close ---------- */

    closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', (e) => {
        if (!container.contains(e.target)) closePopup();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('active')) closePopup();
    });
})();
